import { Config } from "../../store/state/configuration/models/Config";
import { configAdapter } from "../adapters/ConfigAdapter";

export const getRelationship = (relationshipStatuses: Config | undefined, relationshipStatus: number) => {
    return configAdapter(relationshipStatuses, relationshipStatus) || "Батьки";
}